import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';
import { HOMEPAGE } from 'scaleflow/controllers/application';

class LoginRoute extends Route {
  @service session;

  beforeModel() {
    this.session.prohibitAuthentication(HOMEPAGE);
  }
}

export default instrumentRoutePerformance(LoginRoute);
